<div class="header-filter-container">
  @if (type === 'TEXTINPUT' || type === 'COMBO') {
    <div class="text-input-filter">
      <input
        #filterInput
        (keyup)="setFilterDebounced()"
        [(ngModel)]="filterString"
        class="search"
        id="SearchFilter"
        placeholder="Type to Filter"
        type="text"
        />
    </div>
  }
  @if (type === 'SELECT') {
    <div></div>
  }
</div>
